import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AllAdminsLoadAction } from '../../domains/allAdmins/loadActions.types';

import type { Admins } from './types';

const initialState: Admins = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Admins, AllAdminsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_ADMINS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.admins);
    default:
      return state;
  }
};

export default reducer;
